import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const bitcoinHistoricalData = async () => {
  const url = `${backendUrl}/api/screener/charts/btc/`;
  
  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Ошибка при получении данных графиков BTC');
    }
    return await response.json();
  } catch (error) {
    console.error(`Ошибка при отправке GET запроса на ${url}:`, error);
    throw error;
  }
};